module.exports = __webpack_public_path__ + "assets/img/mtTitle-d4dacbad.png";